/**
 * @author jakubbujakowski
 * @since 2020-12-08
 *
 * The role of this component is to oversee the entire Booking module
 * and make changes in booking.reducer based on feature flag state.
 *
 * It should be used when you need to change booking reducer state
 * irrespective of selected booking step (i.e. Cleaning Information, Checkout).
 */

import * as React from "react";
import { useDispatch } from "react-redux";

import { useFeatureToggle } from "@hooks/useFeatureToggle";

import { setHasServiceVouchers } from "@app/redux/booking/booking.actions";

const BookingStateFromFeatureToggleUpdater = React.memo(() => {
  const dispatch = useDispatch();
  const serviceVouchersEnabled = useFeatureToggle("service_voucher");

  React.useEffect(() => {
    if (serviceVouchersEnabled) {
      dispatch(setHasServiceVouchers(true));
      return;
    }
  }, [dispatch, serviceVouchersEnabled]);

  return null;
});

BookingStateFromFeatureToggleUpdater.displayName =
  "BookingStateFromFeatureToggleUpdater";

export { BookingStateFromFeatureToggleUpdater };
